var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-statut"},[_c('StatusesSelector',{attrs:{"element":_vm.entreprise,"isActive":_vm.entreprise.editable_status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }